import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const faqs = [
  { q: 'Why is this not free?', a: 'We charge a small fee to keep the platform free from fake and spam users. Only serious users join.' },
  { q: 'Can I talk to the person directly?', a: 'After you subscribe, you can chat on the platform. Voice/video is not on-site; you may exchange contact after mutual agreement.' },
  { q: 'Is it safe?', a: 'Yes. We verify profiles and prioritize privacy and safety.' },
  { q: 'How are profiles verified?', a: 'Service providers go through our verification process. Normal users can browse without KYC.' },
  { q: 'Can I cancel anytime?', a: 'Your access continues for the paid period. You can choose not to renew.' },
];

const FAQSection = () => {
  const [open, setOpen] = useState(null);

  return (
    <section className="py-16 md:py-24 bg-slate-800/50">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading font-bold text-2xl sm:text-3xl text-white text-center mb-10">
          FAQs
        </h2>
        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl border border-slate-600 overflow-hidden bg-slate-800/60"
            >
              <button
                type="button"
                className="w-full flex items-center justify-between p-4 text-left font-medium text-white hover:bg-slate-700/50 transition-colors"
                onClick={() => setOpen(open === i ? null : i)}
                aria-expanded={open === i}
              >
                {faq.q}
                <ChevronDown
                  className={`h-5 w-5 text-slate-400 transition-transform ${
                    open === i ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {open === i && (
                <div className="px-4 pb-4 text-slate-400 text-sm border-t border-slate-600 pt-2">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
        <p className="mt-6 text-center">
          <Link to="/faq" className="text-brand-pink font-semibold hover:underline">
            View all FAQs
          </Link>
        </p>
      </div>
    </section>
  );
};

export default FAQSection;
